var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.configElement,{tag:"component",staticClass:"mb-0",class:Object.assign({}, _vm.configStyleClasses, _vm.widgetClasses),style:(_vm.configStyles),attrs:{"lang":_vm.value.config.lang},domProps:{"innerHTML":_vm._s(_vm.value.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }